// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification--lJ7","message":"Notification_message--vFQ","button":"Notification_button--q1U","closeIcon":"Notification_closeIcon--oUx"};